

export class SaveFormValues {
  email: string | undefined;
  repeatEmail: string | undefined;
  password: string | undefined;
}
